import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTheme } from '@/context/ThemeContext';

interface NavItem {
  label: string;
  path: string;
  icon: string;
}

const navItems: NavItem[] = [
  { label: 'Dashboard', path: '/', icon: 'ri-dashboard-3-line' },
  { label: 'Randevular', path: '/randevular', icon: 'ri-calendar-check-line' },
  { label: 'Online Randevu', path: '/online-randevu', icon: 'ri-global-line' },
  { label: 'Müşteriler', path: '/musteriler', icon: 'ri-user-smile-line' },
  { label: 'Güvenlik', path: '/güvenlik', icon: 'ri-shield-keyhole-line' },
  { label: 'Hizmetler', path: '/hizmetler', icon: 'ri-drop-line' },
  { label: 'Paketler', path: '/paketler', icon: 'ri-vip-crown-line' },
  { label: 'Finans', path: '/kasa', icon: 'ri-safe-2-line' },
  { label: 'Giderler', path: '/giderler', icon: 'ri-money-cny-circle-line' },
  { label: 'Personel', path: '/personel', icon: 'ri-team-line' },
  { label: 'Stok', path: '/stok', icon: 'ri-stack-line' },
  { label: 'Kampanyalar', path: '/kampanyalar', icon: 'ri-megaphone-line' },
  { label: 'WhatsApp/SMS', path: '/whatsapp-sms', icon: 'ri-whatsapp-line' },
  { label: 'Raporlar', path: '/raporlar', icon: 'ri-bar-chart-box-line' },
  { label: 'Anketler', path: '/anketler', icon: 'ri-survey-line' },
  { label: 'Abonelik', path: '/abonelik', icon: 'ri-vip-diamond-line' },
  { label: 'Ayarlar', path: '/ayarlar', icon: 'ri-settings-4-line' },
];

export default function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { theme } = useTheme();
  const [collapsed, setCollapsed] = useState(false);

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <aside
      className={`hidden lg:flex flex-col h-screen fixed left-0 top-0 z-40 transition-all duration-300 ${
        collapsed ? 'w-20' : 'w-64'
      }`}
      style={{ background: 'var(--sidebar-bg)', borderRight: '1px solid var(--border-color)' }}
    >
      {/* Logo */}
      <div className="flex items-center gap-3 px-5 py-5 border-b" style={{ borderColor: 'var(--border-color)' }}>
        <img
          src="https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/1d51f5ffde24df2b1cca180a545c35bd.jpeg"
          alt="Kuğu Spa"
          className="w-10 h-10 rounded-full object-cover"
        />
        {!collapsed && (
          <div>
            <h1 className="font-display font-semibold text-lg leading-tight" style={{ color: 'var(--text-primary)' }}>
              Kuğu Spa
            </h1>
            <p className="text-[10px] tracking-widest uppercase" style={{ color: 'var(--gold)' }}>
              Yönetim Paneli
            </p>
          </div>
        )}
      </div>

      {/* Nav */}
      <nav className="flex-1 overflow-y-auto py-3 px-3 space-y-1">
        {navItems.map((item) => {
          const active = isActive(item.path);
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-spa-sm text-sm font-medium transition-all cursor-pointer ${
                collapsed ? 'justify-center' : ''
              } ${
                active
                  ? 'bg-theme-sidebar-active'
                  : 'hover:bg-theme-hover'
              }`}
              style={active ? { borderLeft: '3px solid var(--gold)' } : { borderLeft: '3px solid transparent' }}
            >
              <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                <i
                  className={`${item.icon} text-base ${active ? '' : ''}`}
                  style={{ color: active ? 'var(--gold)' : 'var(--text-secondary)' }}
                />
              </div>
              {!collapsed && (
                <span
                  className="truncate"
                  style={{ color: active ? 'var(--text-primary)' : 'var(--text-secondary)' }}
                >
                  {item.label}
                </span>
              )}
            </button>
          );
        })}
      </nav>

      {/* Collapse toggle */}
      <div className="p-3 border-t" style={{ borderColor: 'var(--border-color)' }}>
        <button
          onClick={() => setCollapsed(!collapsed)}
          className="w-full flex items-center justify-center py-2 rounded-spa-sm text-xs font-medium transition-all cursor-pointer"
          style={{ color: 'var(--text-muted)', background: 'var(--bg-tertiary)' }}
        >
          <div className="w-4 h-4 flex items-center justify-center">
            <i className={collapsed ? 'ri-arrow-right-s-line' : 'ri-arrow-left-s-line'} />
          </div>
        </button>
      </div>
    </aside>
  );
}